export enum PROCESSINGSTATES {
    processing = "Takk for at du utførte kontrollen!",
    failed = "Kunne ikke registrere kontrollen, prøv igjen senere!",
    succeeded = "Kontrollen er registrert! Du kan lukke denne siden",
    unset = ""
}

export interface controlLog {
    sid: String
    initials: String,
    comment: String,
    timestamp: Date,
    reportedIssue: Boolean
}